<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'ServiceManual',
  data() {
    return {
    }
  },
  created() {
    window.open('https://alidocs.dingtalk.com/i/nodes/kDnRL6jAJM3L7x9xTDlL9p2KWyMoPYe1?corpId=ding2eed5fbb8a1fa516&utm_medium=im_card&doc_type=wiki_doc&iframeQuery=utm_medium%3Dim_card%26utm_source%3Dim&utm_scene=team_space&utm_source=im&cid=65824995641')
    this.$router.push('/')
  }

}
</script>

<style>

</style>
